import React, { useMemo } from "react";
import "./OpeningComponent.scss";
import { createThemeStyle } from "../utils/themeUtils";

const OpeningComponent = ({
  brideName = "Bride",
  groomName = "Groom",
  weddingData = null,
  isOpening = false,
  onOpen = () => { },
}) => {
  const ceremonyTypeRaw = weddingData?.ceremony_type || "wedding";

  const isHomeComing = useMemo(() => {
    const normalized = String(ceremonyTypeRaw).trim().toLowerCase();
    return (
      normalized === "home coming" ||
      normalized === "homecoming" ||
      normalized === "home-coming"
    );
  }, [ceremonyTypeRaw]);

  const themeStyle = useMemo(
    () => createThemeStyle(weddingData?.theme || {}),
    [weddingData]
  );

  return (
    <div
      className={`floralIntro ${isOpening ? "is-opening" : ""}`}
      aria-hidden={isOpening}
      style={themeStyle}
    >
      <div className="floralIntro__mesh" />
      <div className="floralIntro__bgGrid" />
      <div className="floralIntro__noise" />

      <div className="floralIntro__orb floralIntro__orb--one" />
      <div className="floralIntro__orb floralIntro__orb--two" />
      <div className="floralIntro__orb floralIntro__orb--three" />
      <div className="floralIntro__orb floralIntro__orb--four" />

      <div className="floralIntro__petals floralIntro__petals--left">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="floralIntro__petals floralIntro__petals--right">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="floralIntro__center">
        <div className="floralIntro__archWrap">
          <div className="floralIntro__halo floralIntro__halo--outer" />
          <div className="floralIntro__halo floralIntro__halo--middle" />
          <div className="floralIntro__halo floralIntro__halo--inner" />
          <div className="floralIntro__ringGlow" />

          <div className="floralIntro__sparkles">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>

          <div className="floralIntro__flowers floralIntro__flowers--topLeft">
            <span className="flower flower--lg" />
            <span className="flower flower--md" />
            <span className="flower flower--sm" />
            <span className="leaf leaf--one" />
            <span className="leaf leaf--two" />
          </div>

          <div className="floralIntro__flowers floralIntro__flowers--topRight">
            <span className="flower flower--lg" />
            <span className="flower flower--md" />
            <span className="flower flower--sm" />
            <span className="leaf leaf--one" />
            <span className="leaf leaf--two" />
          </div>

          <div className="floralIntro__flowers floralIntro__flowers--bottomLeft">
            <span className="flower flower--md" />
            <span className="flower flower--sm" />
            <span className="leaf leaf--one" />
          </div>

          <div className="floralIntro__flowers floralIntro__flowers--bottomRight">
            <span className="flower flower--md" />
            <span className="flower flower--sm" />
            <span className="leaf leaf--one" />
          </div>

          <div className="floralIntro__card">
            <div className="floralIntro__badge">
              <span className="floralIntro__badgeDot" />
              {isHomeComing ? "Homecoming Invitation" : "Wedding Invitation"}
            </div>

            <p className="floralIntro__eyebrow">You Are Invited</p>



            <h2 className="floralIntro__title">
              {isHomeComing
                ? <div>
                  <span className="floralIntro__name">{groomName}</span>
                  <span className="floralIntro__amp">&amp;</span>
                  <span className="floralIntro__name">{brideName}</span>
                </div>
                : <div>
                  <span className="floralIntro__name">{brideName}</span>
                  <span className="floralIntro__amp">&amp;</span>
                  <span className="floralIntro__name">{groomName}</span>
                </div>}
            </h2>

            <div className="floralIntro__divider" aria-hidden="true">
              <span />
            </div>

            <p className="floralIntro__subtitle">
              {isHomeComing
                ? "Join us as we celebrate our joyful homecoming together"
                : "Join us as we celebrate love, joy, and unforgettable moments together"}
            </p>

            <button
              type="button"
              className="floralIntro__button"
              onClick={onOpen}
            >
              <span className="floralIntro__buttonText">Open Invitation</span>
              <span className="floralIntro__buttonIcon">→</span>
              <span className="floralIntro__buttonGlow" />
              <span className="floralIntro__buttonShine" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpeningComponent;